module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-up.02a7264e.svg";